export interface PurchaseOrderReportBillOfMaterials {
  productKey: string;
  productDescription: string;
  amountRequired: string;
  unit: string;
}
